module.exports = "/_next/static/images/os_linux-443467dc4b693e66b1581dbc38e25e7f.svg";